export default __webpack_public_path__ + "images/8_habitat.jpg";